<template>
  <div id="app">
    <div class="container">
      <div class="logo" style="text-align:center; margin-top:1rem;">
        <router-link
          v-bind:to="{
            name: 'Home'
          }"
        >
          <img
            class="img-fluid"
            v-bind:src="require('@/assets/imgs/onetwo.png')"
            alt="mr.blue-logo"
          />
        </router-link>
      </div>
      <div style="margin-top:2rem">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios'

export default {
  name: 'App',

  async created() {
    try {
      const json = this.$i18n.locale === 'en' ? '../disorders_en.json' : '../disorders_el.json'
      const res = await axios.get(json)
      this.$store.commit('setQuestData', res.data)
    } catch (e) {
      this.$store.commit('setQuestData', false)
    }
  }
}
</script>

<style lang="scss">
@import 'assets/scss/styles';
</style>
